import {
  CursorArrowRaysIcon,
  HandRaisedIcon,
  ArrowPathIcon,
  CircleStackIcon,
  Square3Stack3DIcon,
  PencilIcon,
  ScaleIcon,
} from "@heroicons/react/24/outline";

export const TOOL_GROUPS = [
  [
    { id: "select", icon: CursorArrowRaysIcon, tip: "drawings.viewer.tool.select", kbd: "V" },
    { id: "pan", icon: HandRaisedIcon, tip: "drawings.viewer.tool.pan", kbd: "H" },
  ],
  [
    { id: "pen", icon: PencilIcon, tip: "drawings.viewer.tool.pen", kbd: "P" },
    { id: "measure", icon: ScaleIcon, tip: "drawings.viewer.tool.measure", kbd: "M" },
  ],
  [
    { id: "arrow", icon: ArrowPathIcon, tip: "drawings.module.arrow", kbd: "A" },
    { id: "circle", icon: CircleStackIcon, tip: "drawings.module.circle", kbd: "O" },
    { id: "rectangular", icon: Square3Stack3DIcon, tip: "drawings.module.rectangular", kbd: "R" },
  ],
];

export const DrawingViewerToolRail = ({ t, tool, onToolChange, canEdit = true }) => {
  // View-only users keep select/pan (navigation) but never see markup tools.
  const groups = canEdit ? TOOL_GROUPS : TOOL_GROUPS.slice(0, 1);
  return (
    <nav className="z-20 hidden w-14 flex-shrink-0 flex-col items-center gap-[3px] border-r border-[#e5e8ec] bg-white py-2 xl:flex">
      {groups.map((group, groupIndex) => (
        <div key={groupIndex} className="flex flex-col items-center gap-[3px]">
          {groupIndex > 0 && <div className="my-1.5 h-px w-[26px] bg-[#e5e8ec]" />}
          {group.map(({ id, icon: Icon, tip, kbd }) => {
            const active = tool === id;
            return (
              <button
                key={id}
                type="button"
                title={`${t(tip)} (${kbd})`}
                onClick={() => onToolChange(id)}
                className={`relative grid h-10 w-10 place-items-center rounded-[10px] border-none transition-colors ${
                  active
                    ? "bg-[#2b6ef0] text-white shadow-[0_2px_6px_rgba(43,110,240,0.35)]"
                    : "bg-transparent text-[#59616d] hover:bg-[#eef0f3] hover:text-[#14171c]"
                }`}
              >
                <Icon className="h-[21px] w-[21px]" />
              </button>
            );
          })}
        </div>
      ))}
    </nav>
  );
};
